import React, { useState } from "react";
import "jspdf-autotable";
import jsPDF from "jspdf";

export default function ExportPDF({ name, data, header, date, report }) {
  var infos = [];
  data.map((info) => {
    infos.push(Object.values((info) === undefined ? 0 : info));
  });

  function print() {
    const doc = new jsPDF("l", "mm", "tabloid");
    // var img = new Image();
    // img.src = logo;
    // doc.addImage(img, 'png', 15, 13, 19, 9);

    doc.text(name, 15, 20);
    if(report === "monthly"){
      doc.setFontSize(12)
      doc.text("Month of: " + date.month, 15, 26);
    }
    if(report === "daily"){
      doc.setFontSize(12)
      doc.text("Date From: " + date.date_from, 15, 26);
      doc.setFontSize(12)
      doc.text("Date To: " + date.date_to, 15, 31);
      if(date.type !== ""){
        doc.text("Type:" + date.type, 15, 36)
      }
    }
    if(report === "item-history"){
      doc.setFontSize(12)
      doc.text("Date From: " + date.date_from, 15, 26);
      doc.setFontSize(12)
      doc.text("Date To: " + date.date_to, 15, 31);
    }
    if(report === "cancelled"){
      doc.setFontSize(12)
      doc.text("Date From: " + date.date_from, 15, 26);
      doc.setFontSize(12)
      doc.text("Date To: " + date.date_to, 15, 31);
    }
    if(report === "discount"){
      doc.setFontSize(12)
      doc.text("Date From: " + date.date_from, 15, 26);
      doc.setFontSize(12)
      doc.text("Date To: " + date.date_to, 15, 31);
    }
  
    doc.autoTable({
      styles: {
        fontSize: 7,
        width: "50px",
      },

      theme: "plain",
      margin: { top: 38 },
      head: [header],
      body: infos,
    });

    doc.save(name + ".pdf");
  }

  return (
    <button className="category-new-export-btn" onClick={print}>
      Export to PDF
    </button>
  );
}
